import { combineReducers } from 'redux';

import dialogs from './dialogs';
import formEditor from './formEditor';
import forms from './forms';
import formResponses from './formResponses';
import formSubmit from './formSubmit';
import formFields from './formFields';
import notifications from './notifications';
import path from './path';
import formActionMenus from './formActionMenus';
import user from './user';
import surveys from './surveys';
import organizations from './organizations';

export default combineReducers({
    dialogs,
    forms,
    formEditor,
    formFields,
    formActionMenus,
    formResponses,
    formSubmit,
    notifications,
    path,
    user,
    surveys,
    organizations
});
